import React, { Component, ErrorInfo, ReactNode } from 'react'
import { Alert } from 'antd'

interface IErrorBoundaryProps {
    children: ReactNode
    fallback?: ReactNode
}

interface IErrorBoundaryState {
    hasError: boolean
    error?: Error
}

/**
 * ErrorBoundary component
 * Catches JavaScript errors anywhere in the child component tree and displays a fallback UI
 */
export class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
    public static getDerivedStateFromError(error: Error): IErrorBoundaryState {
        // Update state so the next render will show the fallback UI
        return { hasError: true, error }
    }

    constructor(props: IErrorBoundaryProps) {
        super(props)
        this.state = { hasError: false }
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // Log error to console for debugging
        console.error('FieldSuggestionResultsManager Error:', error, errorInfo)
    }

    public render() {
        if (this.state.hasError) {
            // Render custom fallback UI or default error message
            return (
                this.props.fallback || (
                    <Alert
                        type="error"
                        showIcon
                        message="Something went wrong"
                        description="An error occurred while loading the field suggestions. Please try again."
                        style={{ margin: 16 }}
                    />
                )
            )
        }

        return this.props.children
    }
}
